<script setup>
import { BModal,BRow, BCol, BForm, BFormInput, BFormSelectOption, BButton, BFormSelect } from 'bootstrap-vue-next';
import { defineProps } from 'vue';
import { ref } from 'vue'

defineProps({
    modal: Boolean,
    updateModal: Function
})

const optionDefault = ref('admin_backoffice')
const prefix = ref(null)
const optionsField =     [
  {value: 'super_admin', text: 'Super Admin'},
  {value: 'admin_backoffice', text: 'Admin Back Office'},
  {value: 'supervisor', text: 'Supervisor'},
  
]



const prefixOptionsField =[
    {text: 'Mr'},
    {text: 'Mr.'},
  
]

</script>

<template>
    <BModal :model-value="modal" scrollable centered >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Admin</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                <BRow >
                    <BCol cols="4">
                        <BFormSelect id="input-1" v-model="prefix" :options="prefixOptionsField" class="form-control">
                            <template #first>
                                <BFormSelectOption :value="null" disabled>Select title</BFormSelectOption>
                            </template>
                        </BFormSelect>
                    </BCol>
                    <BCol cols="8">
                        <BFormInput id="input-1" v-model="name" :state="state" placeholder="Name" class="form-group" />
                    </BCol>
                </BRow>
                <BRow >
                    <BCol>
                        <BFormInput id="input-1" v-model="email" :state="state" placeholder="Email" class="form-group" />
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormInput id="input-1" v-model="password" :state="state" trim placeholder="Password" class="form-group"/>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormInput id="input-1" v-model="password" :state="state" trim placeholder="Konfirmasi Password" class="form-group" />
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormSelect id="input-1" v-model="optionDefault" :options="optionsField" class="form-control" />
                    </BCol>
                </BRow>
            </BContainer>
            
                
        
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

